import { createStore, createEvent } from "effector"
import { IAlertModalProps } from "components/AlertModal/AlertModal"

const show = createEvent<IAlertModalProps>()
const hide = createEvent<IAlertModalProps>()
const clear = createEvent()

const list = createStore<IAlertModalProps[]>([])

list.on(show,
    (state: IAlertModalProps[], alert: IAlertModalProps) => [...state, alert]
)

list.on(hide,
    (state: IAlertModalProps[], alert: IAlertModalProps) => state.filter(a => a !== alert)
)

list.on(clear,
    () => []
)

export default {
    show,
    hide,
    clear,
    list
}
